// Online, the score window between deals: the next deal comes by itself after a few seconds (the server's stay). The
// note stands where the "Next deal" button stands offline, as a quiet pill of the button's size with three pulsing dots
// (owner 2026-10-31, the iPad: a small grey line under the ad, "popraw ten napis"). The text's own "..." is dropped:
// the dots are the animation.
import { t } from '../i18n';

export function NextDealNote() {
  const text = t('lobby.next-deal').replace(/[\s.…]+$/u, '');
  return (
    <p className="hs-wait" role="status">
      <span className="hs-wait__text">{text}</span>
      <span className="hs-wait__dots" aria-hidden="true">
        <i />
        <i />
        <i />
      </span>
    </p>
  );
}
